/**
 * iPhone-style message notification (Tri-tone: G5 → B5 → E6).
 * Uses the bundled wav with a synth fallback.
 */

const SOUND_URL = `${process.env.PUBLIC_URL || ''}/sounds/iphone-message.wav`;

let audioCtx = null;
let notificationAudio = null;

function getAudioContext() {
  const AudioCtx = window.AudioContext || window.webkitAudioContext;
  if (!AudioCtx) return null;
  if (!audioCtx) audioCtx = new AudioCtx();
  return audioCtx;
}

function getNotificationAudio() {
  if (!notificationAudio) {
    notificationAudio = new Audio(SOUND_URL);
    notificationAudio.preload = 'auto';
    notificationAudio.volume = 1;
  }
  return notificationAudio;
}

/** Call during a user gesture (login click, tab tap) so later socket events can play sound. */
export function prepareNewBookingSound() {
  try {
    const ctx = getAudioContext();
    if (ctx?.state === 'suspended') {
      ctx.resume().catch(() => {});
    }
    const audio = getNotificationAudio();
    audio.load();
  } catch {
    // ignore
  }
}

/** Web Audio fallback — iPhone Tri-tone message alert. */
function playSynthesizedTriTone() {
  const ctx = getAudioContext();
  if (!ctx) return;

  const now = ctx.currentTime;
  const volume = 0.72;

  const playNote = (frequency, start, duration) => {
    const osc = ctx.createOscillator();
    const harmonic = ctx.createOscillator();
    const gain = ctx.createGain();

    osc.type = 'sine';
    osc.frequency.value = frequency;
    harmonic.type = 'sine';
    harmonic.frequency.value = frequency * 2;

    gain.gain.setValueAtTime(0.0001, start);
    gain.gain.linearRampToValueAtTime(volume, start + 0.004);
    gain.gain.setValueAtTime(volume * 0.85, start + duration * 0.35);
    gain.gain.exponentialRampToValueAtTime(0.0001, start + duration);

    osc.connect(gain);
    harmonic.connect(gain);
    gain.connect(ctx.destination);

    osc.start(start);
    harmonic.start(start);
    osc.stop(start + duration + 0.03);
    harmonic.stop(start + duration + 0.03);
  };

  playNote(783.99, now, 0.105);
  playNote(987.77, now + 0.135, 0.105);
  playNote(1318.51, now + 0.27, 0.175);
}

export async function playNewBookingSound() {
  try {
    const ctx = getAudioContext();
    if (ctx?.state === 'suspended') {
      await ctx.resume();
    }

    const audio = getNotificationAudio();
    audio.currentTime = 0;
    await audio.play();
  } catch {
    try {
      const ctx = getAudioContext();
      if (ctx?.state === 'suspended') {
        await ctx.resume();
      }
      if (ctx?.state === 'running') {
        playSynthesizedTriTone();
      }
    } catch {
      // autoplay blocked — use prepareNewBookingSound() on login or tab click
    }
  }
}
